export default {
	//buyer search event
	onBuyerPriceSearchButtonClick: 'onBuyerPriceSearchButtonClick',

	//filter event
	onFilterTagButtonClick: 'onFilterTagButtonClick',

	//bahikhata events
	onDetailedKhataScreenCallButtonClick: 'onDetailedKhataScreenCallButtonClick',
	onBahiKhataModalOkeyButtonClick: 'onBahiKhataModalOkeyButtonClick',
	onRecordNewTransactionButtonClick: 'onRecordNewTransactionButtonClick',
	onAddKhataManuallyButtonClick: 'onAddKhataManuallyButtonClick',
	onBahiKhataSearchBoxClick: 'onBahiKhataSearchBoxClick',
	onBahiKhataEditProfileButtonClick: 'onBahiKhataEditProfileButtonClick',
	onBahiKhataContinueNewKhataButtonClick:
		'onBahiKhataContinueNewKhataButtonClick',
	onBahiKhataHomeScreenInputBoxClick: 'onBahiKhataHomeScreenInputBoxClick',
	onBahiKhataHomeScreenFilterButtonClick:
		'onBahiKhataHomeScreenFilterButtonClick',
	onBahiKhataHomeScreenSortButtonClick: 'onBahiKhataHomeScreenSortButtonClick',
	onBahiKhataFilterModalCrossButtonClick:
		'onBahiKhataFilterModalCrossButtonClick',
	onBahiKhataFilterOptionSelected: 'onBahiKhataFilterOptionSelected',
	onBahiKhataSortbyModalCrossButtonClick:
		'onBahiKhataSortbyModalCrossButtonClick',
	onBahiKhataSortbyOptionSelected: 'onBahiKhataSortbyOptionSelected',
	onBahiKhataSaveNewKhataButtonClick: 'onBahiKhataSaveNewKhataButtonClick',
	onBahiKhataContactNumberInputBoxClick: 'onBahiKhataContactNumberInputBoxClick',
	onBahiKhataNameInputBoxClick: 'onBahiKhataNameInputBoxClick',
	onSearchBoxClick: 'onSearchBoxClick',
	onEnableConactPermissionButtonClick: 'onEnableConactPermissionButtonClick',
	onGotoSettingsButtonClick: 'onGotoSettingsButtonClick',
	onAddUserButtonClick: 'onAddUserButtonClick',
	onDetailedKhataScreenMoreSettingButtonClick:
		'onDetailedKhataScreenMoreSettingButtonClick',
	onDetailedKhataScreenReceiveMoneyButtonClick:
		'onDetailedKhataScreenReceiveMoneyButtonClick',
	onDetailedKhataScreenGiveCreditButtonClick:
		'onDetailedKhataScreenGiveCreditButtonClick',
	onDetailedKhataScreenTransactionCardClick:
		'onDetailedKhataScreenTransactionCardClick',
	onDetailedTransactionScreenCrossButtonClick:
		'onDetailedTransactionScreenCrossButtonClick',
	onDetailedTransactionScreenDeleteButtonClick:
		'onDetailedTransactionScreenDeleteButtonClick',
	onDetailedTransactionScreenEditButtonClick:
		'onDetailedTransactionScreenEditButtonClick',
	onDetailedTransactionScreenUploadImageButtonClick:
		'onDetailedTransactionScreenUploadImageButtonClick',
	onDetailedTransactionScreenSendReminderButtonClick:
		'onDetailedTransactionScreenSendReminderButtonClick',
	onDeleteTransactionModalCrossButtonClick:
		'onDeleteTransactionModalCrossButtonClick',
	onDeleteTransactionModalConfirmationButtonClick:
		'onDeleteTransactionModalConfirmationButtonClick',
	onSendReminderModalCrossButtonClick: 'onSendReminderModalCrossButtonClick',
	onSendReminderModalConfirmationButtonClick:
		'onSendReminderModalConfirmationButtonClick',
	onEditNoteModalCrossButtonClick: 'onEditNoteModalCrossButtonClick',
	onEditNoteModalInputBoxClick: 'onEditNoteModalInputBoxClick',
	onEditNoteModalSaveButtonClick: 'onEditNoteModalSaveButtonClick',
	onEditAmountModalCrossButtonClick: 'onEditAmountModalCrossButtonClick',
	onEditAmountModalInputBoxClick: 'onEditAmountModalInputBoxClick',
	onEditAmountModalSaveButtonClick: 'onEditAmountModalSaveButtonClick',
	onImageAttachedScreenCrossButtonClick: 'onImageAttachedScreenCrossButtonClick',
	onBahiKhataImagePreviewScreenDeleteButtonClick:
		'onBahiKhataImagePreviewScreenDeleteButtonClick',
	onBahiKhataImagePreviewConfirmationButtonClick:
		'onBahiKhataImagePreviewConfirmationButtonClick',
	onRecordTransactionScreenDateSelectionButtonClick:
		'onRecordTransactionScreenDateSelectionButtonClick',
	onRecordTransactionScreenAmountInputBoxClick:
		'onRecordTransactionScreenAmountInputBoxClick',
	onRecordTransactionScreenNoteInputBoxClick:
		'onRecordTransactionScreenNoteInputBoxClick',
	onRecordTransactionScreenUploadImageButtonClick:
		'onRecordTransactionScreenUploadImageButtonClick',
	onRecordTransactionScreenSaveButtonClick:
		'onRecordTransactionScreenSaveButtonClick',
	onBahiKhataEditProfileNameInputButtonClick:
		'onBahiKhataEditProfileNameInputButtonClick',
	onBahiKhataEditProfileMobileNumberInputButtonClick:
		'onBahiKhataEditProfileMobileNumberInputButtonClick',
	onBahiKhataEditProfileUpdateDetailsButtonClick:
		'onBahiKhataEditProfileUpdateDetailsButtonClick',
	onBahiKhataDownloadAppButtonClick: 'onBahiKhataDownloadAppButtonClick',
	onLoginScreenPhoneNumberInputBoxClick: 'onLoginScreenPhoneNumberInputBoxClick',
	onLoginScreenContinueButtonClick: 'onLoginScreenContinueButtonClick',
	onChangeLanguageButtonClick: 'onChangeLanguageButtonClick',
	onLoginScreenChangeNumberButtonClick: 'onLoginScreenChangeNumberButtonClick',
	onLoginScreenOTPInputBoxClick: 'onLoginScreenOTPInputBoxClick',
	onLoginScreenBackButtonClick: 'onLoginScreenBackButtonClick',
	onLoginScreenResendOTPButtonClick: 'onLoginScreenResendOTPButtonClick',
	onWalkthroughScreenSkipButtonClick: 'onWalkthroughScreenSkipButtonClick',
	onWalkthroughScreenNextButtonClick: 'onWalkthroughScreenNextButtonClick',
	onWalkthroughScreenGotItButtonClick: 'onWalkthroughScreenGotItButtonClick',
	onLoginScreenFeatureSelected: 'onLoginScreenFeatureSelected',
	onChangeLanguageModalLanguageButtonClick:
		'onChangeLanguageModalLanguageButtonClick',
	onChangeLanguageModalSubmitButtonClick:
		'onChangeLanguageModalSubmitButtonClick',
	onNotificationLanguageButtonClick: 'onNotificationLanguageButtonClick',
	onNotificationLanguageModalLanguageButtonClick:
		'onNotificationLanguageModalLanguageButtonClick',
	onNotificationLanguageModalSubmitButtonClick:
		'onNotificationLanguageModalSubmitButtonClick',
	onNotificationLanguageModalCloseButtonClick:
		'onNotificationLanguageModalCloseButtonClick',

	/* distributor events */
	onHomeScreenDistributorButtonClick: 'onHomeScreenDistributorButtonClick',
	onLocationChangeToggleClick: 'onLocationChangeToggleClick',
	onCategoryToggleClick: 'onCategoryToggleClick',
	onProductTypeToggleClick: 'onProductTypeToggleClick',
	onProductTypeSearch: 'onProductTypeSearch',
	onCardClickWithinTheList: 'onCardClickWithinTheList',

	onlocationinformationbottomsheetclick: 'onlocationinformationbottomsheetclick',
	onlocationchangesearchclick: 'onlocationchangesearchclick',
	onlocationscreenclick: 'onlocationscreenclick',
	onBottomNavigationBarClick: 'onBottomNavigationBarClick',

	/* MySauda events start */
	onMySaudaScreenInputBoxClick: 'onMySaudaScreenInputBoxClick',
	onMySaudaDateFilterClick: 'onMySaudaDateFilterClick',
	onMySaudaDateFilterRangeSelected: 'onMySaudaDateFilterRangeSelected',
	onMySaudaDateFilterCustomDateRangeClick:
		'onMySaudaDateFilterCustomDateRangeClick',
	onMySaudaDateFilterCustomDateApplyButtonClick:
		'onMySaudaDateFilterCustomDateApplyButtonClick',
	onMySaudaDateFilterCustomDateClearButtonClick:
		'onMySaudaDateFilterCustomDateClearButtonClick',
	onMySaudaCardCreateDispatchClick: 'onMySaudaCardCreateDispatchClick',
	/* MySauda events end */

	/* home screen revamped events start */
	onHomeScreenAIInputClick: 'onHomeScreenAIInputClick',
	onHomeScreenBannerButtonClick: 'onHomeScreenBannerButtonClick',
	onQuickAccessButtonClick: 'onQuickAccessButtonClick',
	onHomeScreenTrustBadgeScroll: 'onHomeScreenTrustBadgeScroll',
	onMyUpdatesFeatureClick: 'onMyUpdatesFeatureClick',
	onTopActiveBuyerPricesClick: 'onTopActiveBuyerPricesClick',
	onCritialActionBarClick: 'onCritialActionBarClick',
	onActionPendingBottomSheet: 'onActionPendingBottomSheet',
	onKycConsentNotificationClick: 'onKycConsentNotificationClick',
	supplierInsightOnViewMyOrdersClick: 'supplierInsightOnViewMyOrdersClick',
	/* home screen revamped events end */

	/* supplier ledger events start */
	OnSupplierLedgerTopNavClick: 'OnSupplierLedgerTopNavClick',
	OnSupplierLedgerDateSelect: 'OnSupplierLedgerDateSelect',
	onSupplierLedgerCustomDateSelect: 'onSupplierLedgerCustomDateSelect',
	onSupplierLedgerFilterCustomDateApplyButtonClick:
		'onSupplierLedgerFilterCustomDateApplyButtonClick',
	onSupplierLedgerFilterCustomDateClearButtonClick:
		'onSupplierLedgerFilterCustomDateClearButtonClick',
	OnSupplierLedgerCardClick: 'OnSupplierLedgerCardClick',
	OnSupplierLedgersDetailScreenClick: 'OnSupplierLedgersDetailScreenClick',
	OnSupplierLedgerBackButtonClick: 'OnSupplierLedgerBackButtonClick',
	OnSupplierLedgerModalClick: 'OnSupplierLedgerModalClick',
	OnTransactionNpsVisible: 'OnTransactionNpsVisible',
	OnTransactionNpsSubmitted: 'OnTransactionNpsSubmitted',
	OnTransactionNpsOutcomeVisible: 'OnTransactionNpsOutcomeVisible',
	OnTransactionNpsFollowUpBackToHomeClick:
		'OnTransactionNpsFollowUpBackToHomeClick',
	OnTransactionNpsThankYouHomeRedirect: 'OnTransactionNpsThankYouHomeRedirect',
	OnLedgerDownloadButtonClick: 'OnLedgerDownloadButtonClick',
	OnMySaudaLedgerButtonClick: 'OnMySaudaLedgerButtonClick',

	/* supplier ledger events end */
	OnGuidedFlowView: 'OnGuidedFlowView',
	OnGuidedFlowClicked: 'OnGuidedFlowClicked',
	OnQuizWinnerScreenClicked: 'OnQuizWinnerScreenClicked',
	OnQuizParticipationScreenClicked: 'OnQuizParticipationScreenClicked',
	OnQuizScreenViewed: 'OnQuizScreenViewed',
	OnQuizNextButtonClicked: 'OnQuizNextButtonClicked',
	OnQuizScreenFeatureClicked: 'OnQuizScreenFeatureClicked',
	OnQuizScreenCrossButtonClick: 'OnQuizScreenCrossButtonClick',
	OnQuizScreenBottomsheetClicked: 'OnQuizScreenBottomsheetClicked',
	OnQuizBackButtonClicked: 'OnQuizBackButtonClicked',
	OnQuizAnswerScreenViewed: 'OnQuizAnswerScreenViewed',
	OnQuizWinnersListViewed: 'OnQuizWinnersListViewed',
	OnWinnerboardViewed: 'OnWinnerboardViewed',
	OnKycScreenViewed: 'OnKycScreenViewed',
	OnKycScreenTdsDeclarationClicked: 'OnKycScreenTdsDeclarationClicked',
	OnKycScreenMsmeDeclarationClicked: 'OnKycScreenMsmeDeclarationClicked',
	OnKycScreenConsentCtaClicked: 'OnKycScreenConsentCtaClicked',
	OnKycFinalScreenViewed: 'OnKycFinalScreenViewed',

	// Profile Events
	OnSwitchProfileClick: 'OnSwitchProfileClick',
	OnMyProfileKycDetailsClick: 'OnMyProfileKycDetailsClick',
	OnMyProfileCallButtonClick: 'OnMyProfileCallButtonClick',
	OnSwitchProfileBottomsheetView: 'OnSwitchProfileBottomsheetView',
	OnSwitchProfileBottomsheetClick: 'OnSwitchProfileBottomsheetClick',
	onProfileKycDetailsClicked: 'onProfileKycDetailsClicked',

	// Self KYC Events
	OnMyProfileEditDetailsButtonClick: 'OnMyProfileEditDetailsButtonClick',
	OnEditProfileDetailSaved: 'OnEditProfileDetailSaved',
	OnViewMembershipCard: 'OnViewMembershipCard',
	OnDownloadMembershipCard: 'OnDownloadMembershipCard',
	OnViewKycDetailsClicked: 'OnViewKycDetailsClicked',
	OnViewKycGSTDetailsClicked: 'OnViewKycGSTDetailsClicked',
	OnViewKycPANDetailsClicked: 'OnViewKycPANDetailsClicked',
	OnBankAccountDetailsCardClicked: 'OnBankAccountDetailsCardClicked',
	OnViewKycAddressDetailsClicked: 'OnViewKycAddressDetailsClicked',
	OnViewKycTDSCertificateClicked: 'OnViewKycTDSCertificateClicked',
	OnUpdateGSTDetailsSuccessfully: 'OnUpdateGSTDetailsSuccessfully',
	OnUpdateGSTDetailsRequested: 'OnUpdateGSTDetailsRequested',
	OnGSTchangeNotAllowed: 'OnGSTchangeNotAllowed',
	OnGSTAddressUpdatedSuccesfully: 'OnGSTAddressUpdatedSuccesfully',
	OnAddGSTbuttonClicked: 'OnAddGSTbuttonClicked',
	OnGSTandPANDetailsUpdateRequested: 'OnGSTandPANDetailsUpdateRequested',
	OnBankDetailUpdateRequested: 'OnBankDetailUpdateRequested',
	OnBankDetailUpdateNotAllowed: 'OnBankDetailUpdateNotAllowed',
	OnMSMEDetailsUpdateRequested: 'OnMSMEDetailsUpdateRequested',
	OnAddMSMEbuttonClicked: 'OnAddMSMEbuttonClicked',
	OnPANdetailsScreenViewed: 'OnPANdetailsScreenViewed',
	OnSelfKycEntryClicked: 'OnSelfKycEntryClicked',
	OnSelfKycLandingStarted: 'OnSelfKycLandingStarted',
	OnSelfKycStepCompleted: 'OnSelfKycStepCompleted',
	OnSelfKycStepSkipped: 'OnSelfKycStepSkipped',
	OnSelfKycDropped: 'OnSelfKycDropped',
	OnSelfKycVerifyFailed: 'OnSelfKycVerifyFailed',
	OnSelfKycWizardSubmitted: 'OnSelfKycWizardSubmitted',

	// Community Revamp Events
	onCommunitySearchPageView: 'onCommunitySearchPageView',
	onCommunitySearchSubmit: 'onCommunitySearchSubmit',
	OnCommunityTagClicked: 'OnCommunityTagClicked',
	OnCommunityPollClicked: 'OnCommunityPollClicked',
	onCommunityHomeCardClick: 'onCommunityHomeCardClick',
	onCommentButtonClick: 'onCommentButtonClick',
	onShareButtonClick: 'onShareButtonClick',
	onLikeButtonClick: 'onLikeButtonClick',
	onCommentReplyClick: 'onCommentReplyClick',
	onCommentSubmitButtonClick: 'onCommentSubmitButtonClick',
	onCommentLikeClick: 'onCommentLikeClick',
	onCommentReplyLikeClick: 'onCommentReplyLikeClick',
	OnCommunityBannerClick: 'OnCommunityBannerClick',

	// Login screens and modals
	OnLoginScreenViewed: 'OnLoginScreenViewed',
	onProgressiveSignupCompleted: 'onProgressiveSignupCompleted',
	onLoginScreenOtpContinueButtonClick: 'onLoginScreenOtpContinueButtonClick',
	OnCommunityLoginSkipClick: 'OnCommunityLoginSkipClick',

	// General
	onFeatureFlagsUpdated: 'onFeatureFlagsUpdated',

	//faq events start
	OnHomeScreenFaqButtonClick: 'OnHomeScreenFaqButtonClick',
	OnHelpCentreAIinputClick: 'OnHelpCentreAIinputClick',
	OnHelpCentreCategoryClick: 'OnHelpCentreCategoryClick',
	OnHelpCentreQuestionScreenView: 'OnHelpCentreQuestionScreenView',
	OnHelpCentreQuestionScreenClicked: 'OnHelpCentreQuestionScreenClicked',
	OnHelpCentreFeatureRedirectionClicked: 'OnHelpCentreFeatureRedirectionClicked',
	OnHelpCentreFeedbackButtonClick: 'OnHelpCentreFeedbackButtonClick',
	OnHelpCentreContactButtonClick: 'OnHelpCentreContactButtonClick',
	OnHelpCentreAIpromptClick: 'OnHelpCentreAIpromptClick',

	/* Truecaller Login Events Start */
	onTruecallerLoginButtonClick: 'onTruecallerLoginButtonClick',
	onTruecallerLoginSuccess: 'onTruecallerLoginSuccess',
	onTruecallerLoginError: 'onTruecallerLoginError',
	/* Truecaller Login Events End */

	/* WhatsApp Login Events Start */
	OnWhatsappLoginButtonClick: 'OnWhatsappLoginButtonClick',
	OnWhatsappLoginSuccess: 'OnWhatsappLoginSuccess',
	/* WhatsApp Login Events End */

	/* GST Summary events */
	OnGstMainScreenClick: 'OnGstMainScreenClick',
	OnGstBreakdownScreenViewed: 'OnGstBreakdownScreenViewed',
	OnGstDownloadAllDebitNoteClicked: 'OnGstDownloadAllDebitNoteClicked',
	OnGstBreakdownClicked: 'OnGstBreakdownClicked',
	OnGstDoDebitDownload: 'OnGstDoDebitDownload',

	OnHomeScreenGstWidgetClick: 'OnHomeScreenGstWidgetClick',

	// Dispatch Unloading Optimisation
	OnTradeStateManagementBottomsheetViewed:
		'OnTradeStateManagementBottomsheetViewed',
	OnTradeStateManagementBottomsheetClicked:
		'OnTradeStateManagementBottomsheetClicked',
	OnSwitchBusinessProfileSelected: 'OnSwitchBusinessProfileSelected',

	/* App Update Events */
	appUpdateNowClicked: 'appUpdateNowClicked',
	appUpdateLaterClicked: 'appUpdateLaterClicked',
	appUpdateCheckError: 'appUpdateCheckError',
	/* App Update Events End */

	/* ILQS Events */
	onILQSQuestionViewed: 'onILQSQuestionViewed',
	onILQSQuestionOptionClicked: 'onILQSQuestionOptionClicked',
	onILQSFollowupViewed: 'onILQSFollowupViewed',
	onILQSFollowupOptionClicked: 'onILQSFollowupOptionClicked',
	onILQSQuestionSubmitted: 'onILQSQuestionSubmitted',
	onILQSQuestionSkipped: 'onILQSQuestionSkipped',
	onILQSNotificationQuestionOpened: 'onILQSNotificationQuestionOpened',
	/* ILQS Events End */

	/* Rapid Trade Events */
	onRapidTradeMapIntroExploreClick: 'onRapidTradeMapIntroExploreClick',
	onRapidTradeMapIntroDismissClick: 'onRapidTradeMapIntroDismissClick',
	onRapidTradeMapDistrictClick: 'onRapidTradeMapDistrictClick',
	onRapidTradeLoginGateShown: 'onRapidTradeLoginGateShown',
	onRapidTradeLoginGateCompleted: 'onRapidTradeLoginGateCompleted',
	onRapidTradeRequestCallbackButtonClick:
		'onRapidTradeRequestCallbackButtonClick',
	/* Rapid Trade Events End */
};
